export const adminTypes = {
  FETCH_DATA: 'admin/GETTING_DATA',
  MANAGE_VACANCY: 'admin/MANAGEVACANCY',
  DELETE_VACANCY: 'admin/DELETE_VACANCY',
};
const studentReducerDefaultState = [];

export default (state = studentReducerDefaultState, action) => {
  switch (action.type) {
    case adminTypes.FETCH_DATA:
      return [...action.vacancies];
    case adminTypes.MANAGE_VACANCY:
      return [...state, ...action.newValues];
    case adminTypes.DELETE_VACANCY:
      return [...action.newValues];
    default:
      return state;
  }
};
